import React, { Component } from "react";
import mrDraftLogoGif from '../../../assets/img/draft_logo2.gif';
import { draftServices, title } from "../../../utils/constants";
import slideStyles from "./slide.module.css";
class Slide extends Component {
    componentDidUpdate(prevProps) {
        console.log('prevprops', prevProps);
    }

    slide1() {
        return (
            <div className={`${slideStyles.slide1_bg}`}>
                <div className={`${slideStyles.dark_transparent_screen} d-flex`}>
                    {/* // TODO: #2 minify to hide content_over_video */}
                    <div className={`${slideStyles.center} container`}>
                        <div className={`${slideStyles.padding_mobile} ${slideStyles.msg_container_1}`}>
                            <h3 class="mt-5 fs-4 text-uppercase">Great Work at a Fair Price</h3>
                            <h1 class="display-2 fw-bolder text-capitalize">{title}</h1>
                            <div class="mt-5">
                                <p class="fs-5">
                                    We offer a turnkey solution for installing and maintaining draft beer systems in commercial establishments such as bars, restaurants, breweries and others. The service typically includes a consultation to determine the best system for the establishment's needs, installation of the system, and ongoing maintenance and cleaning to ensure the quality and freshness of the beer.
                                </p>
                            </div>
                        </div>
                        <ul className={`row mt-5 text-sm-start m-auto ${slideStyles.max_md_table}`}>
                            {
                                draftServices.map((service) => (
                                    <li key={service.value} class="col-md-4">
                                        <div>
                                            <i class="fa-solid fa-beer-mug-empty"></i>
                                            <span class="ms-2">{service.label}</span>
                                        </div>
                                    </li>
                                ))
                            }
                        </ul>
                        <div className={`${slideStyles.container_button}`}>
                            <button className={`btn btn-warning px-5 py-3 fs-5 mt-5 ${slideStyles.button_mr_draft}`} type="submit">
                                {
                                    !(this.props.device === 'sm' || this.props.device === 'xs') && <span>Call us</span>
                                }
                                <div class="d-flex">
                                    <div class="m-auto">
                                        <i class="fa-solid fa-phone"></i>
                                        <a className={`ms-2 ${slideStyles.link_mr_draft}`} href="tel:3476666818">
                                            (347)-666-6818
                                        </a>
                                    </div>
                                </div>
                            </button>
                            <button className={`btn btn-warning px-5 py-3 fs-5 mt-5 ms-3 ${slideStyles.button_mr_draft}`} type="submit">
                                {
                                    !(this.props.device === 'sm' || this.props.device === 'xs') && <span>Email us</span>
                                }
                                <div class="d-flex">
                                    <div class="m-auto">
                                        <i class="fa-solid fa-envelope"></i>
                                        <a className={`ms-2 ${slideStyles.link_mr_draft}`} href="mailto:1mrdraft@gmail.com">
                                            1mrdraft@gmail.com
                                        </a>
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    slide2() {
        return (
            <div className={`${slideStyles.slide2_bg} d-flex`}>
                <div className={`${slideStyles.dark_transparent_screen} d-flex`}>
                    <div className={`${slideStyles.center} container`}>
                        <div className={`${slideStyles.padding_mobile}`}>
                            <h3 class="mt-5 fs-4 text-uppercase">Over 20 Years of experience in the Beer Industry</h3>
                            <h1 class="display-2 fw-bolder text-capitalize">{title}</h1>
                            <div class="mt-5">
                                <p class="fs-5">
                                    Our service offers a thorough and reliable cleaning process to ensure the quality and taste of your beer. <br />
                                    Servicing Long Island, Queens, Brooklyn, Bronx and Manhattan (347)-666-6818
                                </p>
                                <div>
                                    <img src={mrDraftLogoGif} class="img-md img-fluid" alt="Mr-Draft animated logo" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    slide3() {
        return (
            <div className={`${slideStyles.slide3_bg} d-flex`}>
                <div className={`${slideStyles.dark_transparent_screen} d-flex`}>
                    <div className={`${slideStyles.center} container`}>
                        <div>
                            <h3 class="mt-5 fs-4 text-uppercase">Family Owned and Operated</h3>
                            <h1 class="display-2 fw-bolder text-capitalize">{title}</h1>
                            <div class="mt-5">
                                <p class="fs-5">
                                    Let us take care of your beerline maintenance needs so you can focus on serving your customers.
                                </p>
                                <div>
                                    <img src={mrDraftLogoGif} class="img-md img-fluid" alt="Mr-Draft animated logo" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <>
                <div id="home_slide_carousel" className={`${slideStyles.slide_carousel} carousel slide`} data-bs-ride="carousel">
                    <div class="carousel-indicators">
                        <button type="button" data-bs-target="#home_slide_carousel" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                        <button type="button" data-bs-target="#home_slide_carousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    </div>

                    <div class="carousel-inner">
                        <div className={`${slideStyles.mrd_slide_item} carousel-item active`}>
                            {this.slide1()}
                        </div>
                        <div className={`${slideStyles.mrd_slide_item} carousel-item`}>
                            {this.slide2()}
                        </div>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#home_slide_carousel" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#home_slide_carousel" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
                </div>
            </>
        )
    }
}

export default Slide;